var $ = require('jquery');
var countUp = require('countup.js');

var stats = {
    init: function(){
        stats.eventHandlers();
        stats.adjustDimensions();
        stats.run();
    },
    eventHandlers: function(){
        $(window).on('load resize',function(){
            stats.adjustDimensions()
        });
    },
    run: function(){      
        $('.block.stats').each(function(){
            var statBlock = $(this);
            // Account for markup of one single stat in span or multiple stats in li
            if(statBlock.find('span.stat-single').length > 0){
                var targetSpan = statBlock.find('span.stat-single');
                var animatedToggle = false
                $(window).on('scroll resize', function(){
                    if(stats.isElementInViewport(targetSpan) && !animatedToggle){
                        animatedToggle = true;
                        setTimeout(function(){
                            stats.animateStats(targetSpan);
                        }, 500);
                    }
                });
            } else {
                stats.animateStats(statBlock.find('li').first());
                statBlock.find('li a').on('click', function(evt){
                    evt.preventDefault();
                    var clickedStat = $(this).parent();
                    if(clickedStat.hasClass('active')){
                        // Clicking the box when closed
                        statBlock.toggleClass('open');
                        
                    } else {
                        // Clicking a selection in the box
                        statBlock.removeClass('open');
                        statBlock.find('li').removeClass('active');
                        clickedStat.addClass('active');
                        clickedStat.parent().prepend(clickedStat);
                        stats.animateStats(clickedStat);
                    }
                });
            }
        });
    },
    adjustDimensions: function(){
        $('.block.stats .stats-selector').each(function(){
            var statSelector = $(this);
            statSelector.parent().css('padding-right', statSelector.outerWidth());
            statSelector.css('height', statSelector.find('li').first().outerHeight());
        });
    },
    animateStats: function(statSelector){
        var statOneAnim = new countUp.CountUp('stat1', statSelector.data('stat-one')),
        statTwoAnim = new countUp.CountUp('stat2', statSelector.data('stat-two')),
        statThreeAnim = new countUp.CountUp('stat3', statSelector.data('stat-three'));
        statOneAnim.start();
        statTwoAnim.start();
        statThreeAnim.start(); 
    },
    isElementInViewport: function(el) {
        el = el[0];
        var rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }   
}

module.exports = stats;